// extracted by mini-css-extract-plugin
export default {"main":"SmartResponse_main__Ee5i0","title":"SmartResponse_title__vhD8j","icon":"SmartResponse_icon__rnHqk","response":"SmartResponse_response__SByI9"};